/**
 * Created by WebStorm.
 * User: athukorala
 * Date: 10/26/20
 * Time: 2:54 PM
 */
export const tempCorporateHeaders = [
  {
    label: 'Logo',
    field: 'photoPath',
    sort: 'asc'
  },
  {
    label: 'Corporate Name',
    field: 'corporateName',
    sort: 'asc'
  },
  {
    label: 'Admin Name',
    field: 'fullName',
    sort: 'asc'
  },
  {
    label: 'Admin Mobile',
    field: 'adminMobile',
    sort: 'asc'
  },
  {
    label: 'Admin Email',
    field: 'adminEmail',
    sort: 'asc'
  },
  {
    label: 'Added DateTime',
    field: 'addedDate',
    sort: 'asc'
  },
  {
    label: 'Status',
    field: 'status',
    sort: 'asc'
  },
  {
    label: 'More Information',
    field: 'more',
    sort: 'asc'
  },
  ];

export const qrCheckInColumns = [
  {
    label:'No',
    field: 'key'
  },
  {
    label: 'Registration Status',
    field: 'status',
    sort: 'asc'
  },
  {
    label: 'Checked In Date & Time',
    field: 'checkedIn',
    sort: 'asc'
  },
  {
    label: 'Permission granted',
    field: 'permission',
    sort: 'asc'
  },
  {
    label: 'Visitor Identity',
    field: 'visitorIdentity',
    sort: 'asc'
  },
  {
    label: 'Visitor Mobile',
    field: 'visitorMobile',
    sort: 'asc',
  },
  {
    label: 'Name',
    field: 'visitorName',
    sort: 'asc',
  },
  {
    label: 'Address',
    field: 'address',
    sort: 'asc',
  },
  {
    label: 'City',
    field: 'city',
    sort: 'asc',
  },
  // {
  //   label: 'District',
  //   field: 'district',
  //   sort: 'asc',
  // },
  // {
  //   label: 'Purpose of Visit',
  //   field: 'visitingPurpose',
  //   sort: 'asc',
  // },
  {
    label: 'MVID',
    field: 'meetingVisitorId',
    sort: 'asc',
  },
  {
    label:'COVID Result',
    field: 'covid',
    sort: 'asc'
  }
];
export const hrViewBranchColumns = [
  {
    label: 'Branch Name',
    field: 'name',
    sort: 'asc'
  },
  {
    label: 'Address',
    field: 'address',
    sort: 'asc'
  },
  // {
  //   label: 'Location',
  //   field: 'location',
  //   sort: 'asc'
  // },
  {
    label: 'Subscription Number',
    field: 'subscription',
    sort: 'asc'
  },
  // {
  //   label: 'View',
  //   field: 'viewlocation',
  //   sort: 'asc'
  // },
  {
    label: 'Building Count',
    field: 'building_count',
    sort: 'asc'
  },
  {
    label: 'QR Code',
    field: 'qr_code',
    sort: 'asc',
  }
];
export const ivcaAllCameraColumns = [
  {
    label:'Camera ID',
    field: 'cameraId',
    sort: 'asc'
  },
  {
    label:'Branch Name',
    field: 'branchName',
    sort: 'asc'
  },
  {
    label: 'Public IP',
    field: 'cameraPublicIp',
    sort: 'asc'
  },
  {
    label: 'RTSP Port',
    field: 'rtspPort',
    sort: 'asc'
  },
  {
    label: 'RTSP URL',
    field: 'rtspUrl',
    sort: 'asc'
  },
  {
    label: 'Username',
    field: 'username',
    sort: 'asc'
  },
  {
    label: 'Suffix',
    field: 'cameraSuffix',
    sort: 'asc'
  },
  {
    label: 'Added By',
    field: 'addedBy',
    sort: 'asc'
  },
  {
    label: 'Added DateTime',
    field: 'addedDate',
    sort: 'asc'
  },
  {
    label: 'Updated By',
    field: 'updatedBy',
    sort: 'asc'
  },
  {
    label: 'Updated DateTime',
    field: 'updatedDate',
    sort: 'asc'
  },
  {
    label: 'Status',
    field: 'visitorCameraStatus',
    sort: 'asc'
  },
  {
    label: 'Actions',
    field: 'actions'
  }
];

export const uploadUsersColumns = [
  {
    label:'No',
    field: 'index',
    sort: 'asc'
  },
  {
    label:'First Name',
    field: 'firstName',
    sort: 'asc'
  },
  {
    label: 'Last Name',
    field: 'lastName',
    sort: 'asc'
  },
  {
    label: 'Gender (optional)',
    field: 'gender',
    sort: 'asc'
  },

  {
    label: 'Email',
    field: 'email',
    sort: 'asc'
  },
  {
    label: 'Mobile Number',
    field: 'mobile',
    sort: 'asc'
  },
  {
    label: 'VIP Points',
    field: 'vipOption',
    sort: 'asc'
  },


];

export const ViewAllVIPUser = [
  {
    label:'No',
    field: 'index',
    sort: 'asc'
  },
  {
    label:'First Name',
    field: 'fName',
    sort: 'asc'
  },
  {
    label: 'Last Name',
    field: 'lName',
    sort: 'asc'
  },
  {
    label: 'Gender (optional)',
    field: 'gender',
    sort: 'asc'
  },

  {
    label: 'Email',
    field: 'email',
    sort: 'asc'
  },
  {
    label: 'Mobile Number',
    field: 'mobile',
    sort: 'asc'
  },
  {
    label: 'VIP Points',
    field: 'vipPoint',
    sort: 'asc'
  },
  {
    label: 'User Type',
    field: 'VIPType',
    sort: 'asc'
  },
  {
    label: 'Change user Type',
    field: 'activeVIP',
    sort: 'asc'
  },
  {
    label: 'Actions',
    field: 'more',
    sort: 'asc'
  },

];

export const ViewAllPublicUser = [
  {
    label:'No',
    field: 'index',
    sort: 'asc'
  },
  {
    label:'First Name',
    field: 'fName',
    sort: 'asc'
  },
  {
    label: 'Last Name',
    field: 'lName',
    sort: 'asc'
  },
  {
    label: 'Gender (optional)',
    field: 'gender',
    sort: 'asc'
  },

  {
    label: 'Email',
    field: 'email',
    sort: 'asc'
  },
  {
    label: 'Mobile Number',
    field: 'mobile',
    sort: 'asc'
  },
  {
    label: 'Identification Value',
    field: 'idValue',
    sort: 'asc'
  },
  {
    label: 'User Type',
    field: 'vip',
    sort: 'asc'
  },
  {
    label: 'Change user Type',
    field: 'activeVIP',
    sort: 'asc'
  },
  {
    label: 'QR Code',
    field: 'qr',
    sort: 'asc'
  },
  {
    label: 'Actions',
    field: 'more',
    sort: 'asc'
  },

];

export const ViewAllCorporateUser = [
  {
    label: 'EMP ID',
    field: 'empID',
    sort: 'asc'
  },
  {
    label: 'First Name',
    field: 'fName',
    sort: 'asc'
  },
  {
    label: 'Last Name',
    field: 'lName',
    sort: 'asc'
  },
  {
    label: 'Mobile No',
    field: 'mobile',
    sort: 'asc'
  },
  {
    label: 'Department',
    field: 'department',
    sort: 'asc'
  },

  {
    label: 'Identification Type',
    field: 'idType',
    sort: 'asc'
  },
  {
    label: 'Identification Value',
    field: 'idValue',
    sort: 'asc'
  },
  {
    label: 'Email',
    field: 'email',
    sort: 'asc'
  },
  {
    label: 'User Type',
    field: 'vip',
    sort: 'asc'
  },
  {
    label: 'Change user Type',
    field: 'activeVIP',
    sort: 'asc'
  },
  {
    label: 'Actions',
    field: 'more',
    sort: 'asc'
  },
];

export const uploadCorporateUsersColumns = [
  {
    label:'No',
    field: 'index',
    sort: 'asc'
  },
  {
    label:'Title',
    field: 'title',
    sort: 'asc'
  },
  {
    label: 'Gender (optional)',
    field: 'gender',
    sort: 'asc'
  },
  {
    label:'First Name',
    field: 'firstName',
    sort: 'asc'
  },
  {
    label: 'Last Name',
    field: 'lastName',
    sort: 'asc'
  },
  {
    label: 'Email',
    field: 'email',
    sort: 'asc'
  },
  {
    label: 'Mobile Number',
    field: 'mobile',
    sort: 'asc'
  },
  {
    label: 'Identification Type',
    field: 'identificationType',
    sort: 'asc'
  },
  {
    label: 'Identification Value',
    field: 'identificationValue',
    sort: 'asc'
  },

  {
    label: 'Address Line 1 (optional)',
    field: 'line1',
    sort: 'asc'
  },
  {
    label: 'Address Line 2 (optional)',
    field: 'line2',
    sort: 'asc'
  },
  {
    label: 'Province/State (optional)',
    field: 'province',
    sort: 'asc'
  },
  {
    label: 'District (optional)',
    field: 'district',
    sort: 'asc'
  },
  {
    label: 'City/Town (optional)',
    field: 'city'
  },
  {
    label: 'Zip Code (optional)',
    field: 'postalCode'
  },
  {
    label: 'Emergency Contact - Full Name (optional)',
    field: 'fullName'
  },
  {
    label: 'Emergency Contact - Mobile Number (optional)',
    field: 'emergency_mobile'
  },
  {
    label: 'Company - Emp ID',
    field: 'empId'
  },
  {
    label: 'Company - Department',
    field: 'department'
  },
  {
    label: 'Company - Designation',
    field: 'designation'
  },
  {
    label: 'Company - Budget Reference (optional)',
    field: 'budgetReferance'
  },
  {
    label: 'Company - Other Reference (optional)',
    field: 'otherReferance'
  },
  {
    label: 'Company - Extension (optional)',
    field: 'extention'
  }
];

export const ViewAllCategorizedUser = [
  {
    label:'No',
    field: 'index',
    sort: 'asc'
  },
  {
    label:'First Name',
    field: 'fName',
    sort: 'asc'
  },
  {
    label: 'Last Name',
    field: 'lName',
    sort: 'asc'
  },
  {
    label: 'Email',
    field: 'email',
    sort: 'asc'
  },
  {
    label: 'Mobile Number',
    field: 'mobile',
    sort: 'asc'
  }
];

export const checkoutColumns = (t=null) => {
  return [
    {
      label: t !== null ? t('tag_color') : 'Tag Color',
      field: 'tagColor',
      sort: 'asc'
    },
    {
      label: t !== null ? t('status') : 'Status',
      field: 'status',
      sort: 'asc'
    },
    {
      label: t !== null ? t('pass_number') : 'Pass Number',
      field: 'passNumber',
      sort: 'asc'
    },
    {
      label: t !== null ? t('checked_in') : 'Checked In',
      field: 'checkedIn',
      sort: 'asc'
    },
    {
      label: t !== null ? t('checked_out') : 'Checked Out',
      field: 'checkedOut',
      sort: 'asc'
    },
    {
      label: t !== null ? t('host_1') : 'Host 1',
      field: 'host1',
      sort: 'asc',
    },
    {
      label: t !== null ? t('host_1_mobile') : 'Host 1 Mobile',
      field: 'host1Mobile',
      sort: 'asc',
    },
    {
      label: t !== null ? t('host_2') : 'Host 2',
      field: 'host2',
      sort: 'asc',
    },
    {
      label: t !== null ? t('host_2_mobile') : 'Host 2 Mobile',
      field: 'host2Mobile',
      sort: 'asc',
    },
    {
      label: t !== null ? t('visitor') : 'Visitor',
      field: 'visitor',
      sort: 'asc',
    },
    {
      label: t !== null ? t('visitor_identity') : 'Visitor Identity',
      field: 'visitorIdentity',
      sort: 'asc',
    },
    {
      label: t !== null ? t('visitor_mobile') : 'Visitor Mobile',
      field: 'visitorMobile',
      sort: 'asc',
    },
    {
      label: t !== null ? t('company') : 'Company',
      field: 'company',
      sort: 'asc',
    },
    {
      label: t !== null ? t('purpose_of_visit') : 'Purpose of Visit',
      field: 'purposeOfVisit',
      sort: 'asc',
    },
    {
      label: t !== null ? t('activated_package') : 'Activated Package',
      field: 'activatedPackage',
      sort: 'asc',
    },
    {
      label: t !== null ? t('generated_pin') : 'Generated PIN',
      field: 'generatedPin',
      sort: 'asc',
    },
    {
      label: t !== null ? t('expire_date') : 'Expire Date',
      field: 'expireDate',
      sort: 'asc',
    },
    {
      label: t !== null ? t('registration_status') : 'Registration Status',
      field: 'registrationStatus',
      sort: 'asc'
    },
    {
      label:t !== null ? t('receptionist_name') : 'Receptionist Name',
      field: 'receptionistName',
      sort: 'asc'
    },
  ]
}

export const inquiryColumns = (t=null) => {
  return [
    {
      label: t !== null ? t('open_by') : 'Open By',
      field: 'openby'
    },
    {
      label: t !== null ? t('close_by') : 'Close By',
      field: 'closeby'
    },
    {
      label: t !== null ? t('open_date') : 'Open Date',
      field: 'opendate'
    },
    {
      label: t !== null ? t('close_date') : 'Close Date',
      field: 'closedDate'
    },
    {
      label: t !== null ? t('status') : 'Status',
      field: 'inquirieStatus'
    },
    {
      label: t !== null ? t('message') : 'Message',
      field: 'message'
    },
    {
      label: t !== null ? t('last_update') : 'Last Update',
      field: 'lastupdate'
    },
    {
      label: t !== null ? t('updated_by') : 'Updated By',
      field: 'updatedby'
    },
    {
      label: t !== null ? t('change_status') : 'Change Status',
      field: 'changestatus'
    },
    {
      label: t !== null ? t('more_information') : 'More Information',
      field: 'more'
    }
  ];
}

//copied from Reception_SheduleMeetingReducer for language change in reception dashboard. Only used for it.
export const visitorsColumns = (t=null) => {
  return [
    {
      label: t !== null ? t('identity') : 'Identity',
      field: 'id'
    },
    {
      label: t !== null ? t('mobile') : 'Mobile',
      field: 'mobile'
    },
    {
      label: t !== null ? t('first_name') : 'First Name',
      field: 'fname'
    },
    {
      label: t !== null ? t('last_name') : 'Last Name',
      field: 'lname'
    },
    {
      label: t !== null ? t('pass_number') : 'Pass Number',
      field: 'pass'
    },
    {
      label: t !== null ? t('vehicle_no.') : 'Vehicle No',
      field: 'vehicleNo'
    },
    {
      label: t !== null ? t('children') : 'Children',
      field: 'children'
    },
    {
      label: t !== null ? t('remove') : 'Remove',
      field: 'remove'
    }
  ];
}

// copied from ViewAllCheckINReducer for language change in reception overdue view.Only used for it.
export const selectedVisitorsColumns = (t=null) => {
  return [
    {
      label: '',
      field: 'checkOut',
      sort: 'asc'
    },
    {
      label: t !== null ? t('pass_number') : 'Pass Number',
      field: 'passNumber',
      sort: 'asc'
    },
    {
      label: t !== null ? t('visitor_identity') : 'Visitor Identity',
      field: 'visitorIdentity',
      sort: 'asc',
    },
    {
      label: t !== null ? t('visitor') : 'Visitor',
      field: 'visitor',
      sort: 'asc',
    },
    {
      label: t !== null ? t('visitor_mobile') : 'Visitor Mobile',
      field: 'visitorMobile',
      sort: 'asc',
    },
  ];
}

//copied from ViewAllCheckINReducer for language change in reception
export const checkOutCols = (t=null) => {
  return [
    {
      label: t !== null ? t('check_out') : 'Check Out',
      field: 'checkOut',
      sort: 'asc'
    },
    {
      label: t !== null ? t('tag_color') : 'Tag Color',
      field: 'tagColor',
      sort: 'asc'
    },
    {
      label: t !== null ? t('status') : 'Status',
      field: 'status',
      sort: 'asc'
    },
    {
      label: t !== null ? t('pass_number') : 'Pass Number',
      field: 'passNumber',
      sort: 'asc'
    },
    {
      label: t !== null ? t('checked_in') : 'Checked In',
      field: 'checkedIn',
      sort: 'asc'
    },
    {
      label: t !== null ? t('checked_out') : 'Checked Out',
      field: 'checkedOut',
      sort: 'asc'
    },
    {
      label: t !== null ? t('host_1') : 'Host 1',
      field: 'host1',
      sort: 'asc',
    },
    {
      label: t !== null ? t('host_1_mobile') : 'Host 1 Mobile',
      field: 'host1Mobile',
      sort: 'asc',
    },
    {
      label: t !== null ? t('host_2') : 'Host 2',
      field: 'host2',
      sort: 'asc',
    },
    {
      label: t !== null ? t('host_2_mobile') : 'Host 2 Mobile',
      field: 'host2Mobile',
      sort: 'asc',
    },
    {
      label: t !== null ? t('visitor') : 'Visitor',
      field: 'visitor',
      sort: 'asc',
    },
    {
      label: t !== null ? t('visitor_identity') : 'Visitor Identity',
      field: 'visitorIdentity',
      sort: 'asc',
    },
    {
      label: t !== null ? t('visitor_mobile') : 'Visitor Mobile',
      field: 'visitorMobile',
      sort: 'asc',
    },
    {
      label: t !== null ? t('company') : 'Company',
      field: 'company',
      sort: 'asc',
    },
    {
      label: t !== null ? t('purpose_of_visit') : 'Purpose of Visit',
      field: 'purposeOfVisit',
      sort: 'asc',
    },
    {
      label: t !== null ? t('activated_package') : 'Activated Package',
      field: 'activatedPackage',
      sort: 'asc',
    },
    {
      label: t !== null ? t('generated_pin') : 'Generated pin',
      field: 'generatedPin',
      sort: 'asc',
    },
    {
      label: t !== null ? t('expire_date') : 'Expire Date',
      field: 'expireDate',
      sort: 'asc',
    },
    {
      label: t !== null ? t('registration_status') : 'Registration Status',
      field: 'registrationStatus',
      sort: 'asc'
    },
    {
      label: t !== null ? t('receptionist_name') : 'Receptionist Name',
      field: 'receptionName',
      sort: 'asc'
    }
  ];
}

// copied from Reception_SheduleMeetingReducer for language change in reception
export const visitorsOfflineErrorsLists = (t=null) => {
  return [
    {
      label: t !== null ? t('row_number') : 'Row Number',
      field: 'row'
    },
    {
      label: t !== null ? t('error_message') : 'Error Message',
      field: 'message'
    },
  ];
}

export const visitorsOfflineColumns = (t=null) => {
  return [
    {
      label: t !== null ? t('row_number') : 'Row Number',
      field: 'index'
    },
    {
      label: t !== null ? t('host_A_-_mobile') : 'Host A - Mobile',
      field: 'hostAMobile'
    },
    {
      label: t !== null ? t('host_B_-_mobile_(optional)') : 'Host B - Mobile (optional)',
      field: 'hostBMobile'
    },
    {
      label: t !== null ? t('building') : 'Building',
      field: 'buildingName'
    },
    {
      label: t !== null ? t('floor') : 'Floor',
      field: 'floorName'
    },
    {
      label: t !== null ? t('pass_number') : 'Pass Number',
      field: 'cardName'
    },
    {
      label: t !== null ? t('visiting_purpose') : 'Visiting Purpose',
      field: 'visitingPurpose'
    },
    {
      label: t !== null ? t('identification_number') : 'Identification Number',
      field: 'identificationValue'
    },
    {
      label: t !== null ? t('first_name') : 'First Name',
      field: 'firstName'
    },
    {
      label: t !== null ? t('last_name') : 'Last Name',
      field: 'lastName'
    },
    {
      label: t !== null ? t('title') : 'Title',
      field: 'title'
    },
    {
      label: t !== null ? t('email_(optional)') : 'Email (optional)',
      field: 'email'
    },
    {
      label: t !== null ? t('mobile') : 'Mobile',
      field: 'mobile'
    },
    {
      label: t !== null ? t('company_(optional)') : 'Company (optional)',
      field: 'companyName'
    },
    {
      label: t !== null ? t('checkInDate') : 'CheckInDate',
      field: 'checkInDate'
    },
    {
      label: t !== null ? t('checkOutDate') : 'CheckOutDate',
      field: 'checkOutDate'
    },
    {
      label: t !== null ? t('refNo') : 'RefNo',
      field: 'refNo'
    },
  ];
}

